import { useGetDocumentUploadTypes } from "@/hooks/queryHooks/configHooks";
import type { Document } from "@repo/types";

export const DocumentUploadTypeName = ({
  type,
}: {
  type: Document["uploadType"];
}) => {
  const { data: uploadTypes } = useGetDocumentUploadTypes();

  return (
    <p>
      {uploadTypes?.uploadTypes.find((uploadType) => uploadType.id === type)
        ?.label ?? type}
    </p>
  );
};
